import axios from "axios";
import { CART_ADD_ITEM, CART_REMOVE_ITEM , CART_SAVE_PAYMENT_METHOD, CART_SAVE_SHIPPING_ADDRESS } from "../constants/cartConstants";

const server_URL = "https://amazona-backend-mfc1.onrender.com"
export const addToCart=(id,qty)=> async (dispatch , getState)=>{
    const {data} = await axios.get(`${server_URL}/api/products/${id}`)
    console.log(data ,'data');
    dispatch({
        type:CART_ADD_ITEM,
        payload:{
            product:data._id,
            name:data.name,
            image:data.image,
            price:data.price,
            countInStock:data.countInStock,
            qty
        }
    })
    localStorage.setItem('cartItems',JSON.stringify(getState().cart.cartItems))
}

export const saveShippingAddress=(data)=> dispatch =>{
    dispatch({
        type : CART_SAVE_SHIPPING_ADDRESS,
        payload : data
    })
    localStorage.setItem('shippingAddress' , JSON.stringify(data))
}

export const savePaymentMethod=(data) => (dispatch) =>{
    dispatch({
        type: CART_SAVE_PAYMENT_METHOD,
        payload: data
    })
    console.log(data)
    localStorage.setItem('paymentmethod' , JSON.stringify(data))
} 

export const removeFromCart= (id) =>(dispatch , getState)=>{
    dispatch({
        type:CART_REMOVE_ITEM,
        payload : id
    })
    localStorage.setItem('cartItems', JSON.stringify(getState().cart.cartItems));
}